import React, { Suspense } from 'react';
import Main from './Main';
import PreLoader from '../common/PreLoader';
import useModuleLoader from '../../hooks/useModuleLoader';
import { Bundles } from '../../util/moduleLoader';

const MainAsync = () => {
  const load = useModuleLoader(Bundles.Main, 'Main');

  return (
    <Suspense fallback={<PreLoader />}>{load ? <Main /> : undefined}</Suspense>
  );
};
export default MainAsync;
